"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[783],{

/***/ 2290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    @media ( max-width: ",
        "px ) {\n      svg {\n        &:first-child {\n          display: none;\n        }\n\n        &:last-child {\n          display: block;\n        }\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  svg {\n    &:first-child {\n      display: block;\n    }\n\n    &:last-child {\n      display: none;\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


function BrixelLogo(param) {
    var _breakpoint = param.breakpoint, breakpoint = _breakpoint === void 0 ? null : _breakpoint;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledBrixelLogo, {
        $breakpoint: breakpoint,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                width: "99",
                height: "33",
                viewBox: "0 0 99 33",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MarquePaths, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TextPaths, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                width: "33",
                height: "33",
                viewBox: "0 0 33 33",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MarquePaths, {})
            })
        ]
    });
}
function MarquePaths() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M15.4105 0.320801H0V15.8401H15.4105V0.320801Z",
                fill: "#009877"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M24.4011 0.15918C20.0556 0.15918 16.5342 3.70549 16.5342 8.08169C16.5342 12.4555 20.0556 16.0042 24.4011 16.0042C28.7442 16.0042 32.2681 12.4579 32.2681 8.08169C32.2657 3.70549 28.7442 0.15918 24.4011 0.15918Z",
                fill: "#FF595A"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M24.5614 17.1333H0V32.6526H24.5614C28.8159 32.6526 32.2679 29.1787 32.2679 24.8918C32.2655 20.6072 28.8159 17.1333 24.5614 17.1333Z",
                fill: "#00C1DE"
            })
        ]
    });
}
function TextPaths() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M54.0527 17.3558C53.5264 16.6763 52.828 16.2414 51.9542 16.0545C52.7201 15.8677 53.3375 15.4735 53.8098 14.8722C54.2821 14.2708 54.5149 13.4962 54.5149 12.5516C54.5149 11.3319 54.1235 10.3874 53.3375 9.71465C52.5514 9.04193 51.4279 8.70557 49.9671 8.70557H43.8809V23.8826H50.0886C51.6304 23.8826 52.8112 23.5122 53.6209 22.7749C54.4339 22.0377 54.8388 21.0286 54.8388 19.7545C54.8422 18.8338 54.579 18.0353 54.0527 17.3558ZM46.7722 11.1314H49.3328C50.0987 11.1314 50.6655 11.3047 51.0332 11.6479C51.4009 11.991 51.5865 12.4803 51.5865 13.1088C51.5865 13.7374 51.3976 14.2232 51.0231 14.5596C50.6486 14.896 50.0987 15.0658 49.3733 15.0658H46.7722V11.1314ZM51.2761 20.8791C50.8679 21.229 50.2775 21.4057 49.515 21.4057H46.7688V17.2369H49.4948C50.2606 17.2369 50.851 17.4204 51.266 17.7839C51.681 18.1508 51.8901 18.6673 51.8901 19.3434C51.8935 20.0161 51.6877 20.5291 51.2761 20.8791Z",
                fill: "#06262D"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M59.6456 15.0792C60.047 14.3861 60.5801 13.8391 61.2447 13.4382C61.9093 13.0373 62.9282 12.4937 63.7447 12.4937L63.7379 15.3272C61.7238 15.3272 59.6422 16.9581 59.6422 19.4757V23.8755H56.8926V12.8402H59.6422V15.0792H59.6456Z",
                fill: "#06262D"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M68.5432 12.8403V23.8791H65.8037V12.8403H68.5432Z",
                fill: "#06262D"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M78.5052 23.8791L76.0491 20.563L73.7718 23.8791H70.5938L74.4668 18.3138L70.5971 12.8403H73.7516L76.0525 16.1088L78.4816 12.8403H81.5551L77.655 18.3172L81.5551 23.8791H78.4006H78.5052Z",
                fill: "#06262D"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M98.6809 8.70215V23.8791H95.9414V8.70215H98.6809Z",
                fill: "#06262D"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M67.1728 11.8074C68.1194 11.8074 68.8867 11.0347 68.8867 10.0814C68.8867 9.12821 68.1194 8.35547 67.1728 8.35547C66.2263 8.35547 65.459 9.12821 65.459 10.0814C65.459 11.0347 66.2263 11.8074 67.1728 11.8074Z",
                fill: "#06262D"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                d: "M89.8207 21.3953C89.3753 21.7249 88.8153 21.8914 88.1439 21.8914C87.3882 21.8914 86.7573 21.6502 86.2512 21.1677C85.7418 20.6852 85.4753 20.0669 85.4348 19.051H93.7713C93.8388 18.6807 93.8894 18.2152 93.8894 17.9264C93.8894 16.8799 93.66 15.949 93.2012 15.1302C92.7423 14.3114 92.0878 13.6692 91.2444 13.2004C90.401 12.7315 89.4158 12.4971 88.289 12.4971C87.1756 12.4971 86.1905 12.7315 85.3235 13.2004C84.4598 13.6692 83.785 14.3454 83.306 15.2355C82.8269 16.1223 82.584 17.1653 82.584 18.3647C82.584 19.5606 82.8235 20.6003 83.306 21.4837C83.785 22.3636 84.4598 23.0432 85.3235 23.5188C86.1871 23.9945 87.1756 24.2323 88.289 24.2323C89.237 24.2323 90.0973 24.0522 90.8733 23.6955C91.6492 23.3387 92.2835 22.8427 92.7761 22.2074C93.191 21.6739 93.4846 21.0862 93.6566 20.4372H90.5629C90.4077 20.8211 90.1614 21.1405 89.8207 21.3953ZM86.3086 15.5107C86.845 15.0283 87.5029 14.787 88.2856 14.787C89.0548 14.787 89.7026 15.0283 90.2323 15.5107C90.6304 15.8709 90.8665 16.3635 90.9408 16.9819C91.0622 16.9819 86.8214 16.9819 85.5124 16.9819C85.6406 16.3635 85.9071 15.8743 86.3086 15.5107Z",
                fill: "#06262D"
            })
        ]
    });
}
var StyledBrixelLogo = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8dedb30e-0"
})(_templateObject1(), function(p) {
    return p.$breakpoint && (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_templateObject(), p.$breakpoint);
});
/* harmony default export */ __webpack_exports__["Z"] = (BrixelLogo);


/***/ }),

/***/ 7940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    background: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    color: ",
        ";\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var Background = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.attrs */ .ZP.div.attrs(function(p) {
    return {
        className: "".concat(p.$color ? "bx-background--color_".concat(p.$color) : "")
    };
}).withConfig({
    componentId: "sc-9bc7dbb4-0"
})(_templateObject2(), function(p) {
    return p.$color && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject(), p.theme.getColor(p.$color));
}, function(p) {
    return p.$textColor && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject1(), p.theme.getColor(p.$textColor));
});
/* harmony default export */ __webpack_exports__["Z"] = (Background);


/***/ }),

/***/ 4970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nv": function() { return /* binding */ getStackValue; },
/* harmony export */   "vO": function() { return /* binding */ StackItem; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2125);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    height: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      gap: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    flex-direction: column;\n    justify-content: ",
        ";\n    align-items: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    > * {\n      padding-bottom: ",
        ";\n\n      &:last-child {\n        padding-bottom: 0;\n      }\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding-top: ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    position: relative;\n    padding-bottom: ",
        ";\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  ",
        "\n\n  ",
        "\n\n  > * {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding-top: ",
        ";\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding-top: 0;\n    margin-top: auto;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding-bottom: ",
        ";\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    padding-bottom: 0;\n    margin-bottom: auto;\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n  \n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}

var getStackValue = function(stack) {
    return "calc( ".concat(stack, " * var( --stack-basis ) )");
};
var Stack = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c6dde5c4-0"
})(_templateObject6(), function(p) {
    return p.$height && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject(), p.$height);
}, function(p) {
    return p.$flex && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject2(), p.$justifyContent, p.$alignItems, p.$between && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject1(), getStackValue(p.$between)));
}, function(p) {
    return !p.$flex && p.$between && typeof p.$between === "number" && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject3(), getStackValue(p.$between));
}, function(p) {
    return p.$top && typeof p.$top === "number" && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject4(), getStackValue(p.$top));
}, function(p) {
    return p.$bottom && typeof p.$bottom === "number" && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject5(), getStackValue(p.$bottom));
});
Stack.defaultProps = {
    $justifyContent: "flex-start",
    $alignItems: "flex-start"
};
/* harmony default export */ __webpack_exports__["ZP"] = (Stack);
var StackItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c6dde5c4-1"
})(_templateObject11(), function(p) {
    return p.$top && p.$top !== "auto" && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject7(), getStackValue(p.$top));
}, function(p) {
    return p.$top && p.$top === "auto" && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject8());
}, function(p) {
    return p.$bottom && p.$bottom !== "auto" && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject9(), getStackValue(p.$bottom));
}, function(p) {
    return p.$bottom && p.$bottom === "auto" && (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject10());
});


/***/ }),

/***/ 8549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NavigationBar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(570);
;// CONCATENATED MODULE: ./components/navigationBar/NavBarButton.tsx


function NavBarButton(param) {
    var url = param.url, text = param.text, target = param.target, color = param.color, buttonStyle = param.buttonStyle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
        href: url,
        target: target,
        outline: buttonStyle !== "primary",
        color: color,
        size: "small",
        children: text
    });
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./hooks/useModalTraits.tsx + 3 modules
var useModalTraits = __webpack_require__(3974);
;// CONCATENATED MODULE: ./components/Dropdown.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    opacity: 1;\n    pointer-events: all;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  position: absolute;\n  right: 0;\n  top: calc( 100% + ( 2 * var( --stack-basis)) );\n  width: max-content;\n  min-width: 250px;\n  max-width: 80vw;\n  border-radius: var( --card-border-radius );\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.12);\n  background: ",
        ";\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity .3s ease-out;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border-bottom: 1px solid ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  background: ",
        ";\n\n  a,\n  button {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n    padding: 10px 12px;\n    border: 0;\n    background: ",
        ";\n    font-size: ",
        ";\n    text-align: left;\n    text-decoration: none;\n    color: inherit;\n    cursor: pointer;\n    transition: background .3s ease-out;\n\n    &:hover {\n      background: ",
        ";\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  all: unset;\n  cursor: pointer;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}





function Dropdown(param) {
    var toggler = param.toggler, dropdownItems = param.dropdownItems, _closeOnSelect = param.closeOnSelect, closeOnSelect = _closeOnSelect === void 0 ? true : _closeOnSelect;
    var containerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    (0,useModalTraits/* default */.Z)({
        containerRef: containerRef,
        isOpen: isOpen,
        close: function() {
            return setIsOpen(false);
        },
        preventBodyScroll: false
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDropdown, {
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggler, {
                toggler: toggler,
                toggleDropdown: function() {
                    return setIsOpen(function(s) {
                        return !s;
                    });
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDropdownList, {
                $isOpen: isOpen,
                onClick: function() {
                    return closeOnSelect && setIsOpen(false);
                },
                children: dropdownItems.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledItem, {
                        $withSeparator: item.withSeparator,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownItem, {
                            onClick: item.onClick,
                            href: item.href,
                            target: item.target,
                            children: item.children
                        })
                    }, item.id);
                })
            })
        ]
    });
}
function Toggler(param) {
    var toggler = param.toggler, toggleDropdown = param.toggleDropdown;
    if (typeof toggler === "string") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
            onClick: toggleDropdown,
            children: toggler
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapperButton, {
        type: "button",
        onClick: toggleDropdown,
        children: toggler
    });
}
function DropdownItem(param) {
    var _onClick = param.onClick, onClick = _onClick === void 0 ? null : _onClick, _href = param.href, href = _href === void 0 ? null : _href, _target = param.target, target = _target === void 0 ? null : _target, _children = param.children, children = _children === void 0 ? null : _children;
    if (onClick) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* UnstyledButton */.kG, {
            onClick: onClick,
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* UnstyledButton */.kG, {
        href: href,
        target: target,
        children: children
    });
}
var StyledDropdown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5cddea9-0"
})(_templateObject());
var StyledDropdownList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5cddea9-1"
})(_templateObject2(), function(p) {
    return p.theme.colors.realWhite;
}, function(p) {
    return p.$isOpen && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
});
var StyledItem = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e5cddea9-2"
})(_templateObject4(), function(p) {
    return p.theme.colors.realWhite;
}, function(p) {
    return p.theme.colors.realWhite;
}, function(p) {
    return p.theme.typo.sizes.small;
}, function(p) {
    return p.theme.colors.green100;
}, function(p) {
    return p.$withSeparator && (0,styled_components_browser_esm/* css */.iv)(_templateObject3(), p.theme.colors.grey200);
});
var StyledWrapperButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-e5cddea9-3"
})(_templateObject5());

;// CONCATENATED MODULE: ./components/icons/MenuIcon.tsx

function MenuIcon(param) {
    var _title = param.title, title = _title === void 0 ? null : _title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "25",
        height: "14",
        viewBox: "0 0 25 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                y: "0.100098",
                width: "25",
                height: "1",
                fill: "#323E48"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                y: "6.5",
                width: "25",
                height: "1",
                fill: "#323E48"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                y: "12.8999",
                width: "25",
                height: "1",
                fill: "#323E48"
            })
        ]
    });
}
/* harmony default export */ var icons_MenuIcon = (MenuIcon);

;// CONCATENATED MODULE: ./components/icons/UserNavIcon.tsx

function UserNavIcon(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.75391 15C1.75391 11.5962 4.51319 8.83696 7.91695 8.83696C11.3207 8.83696 14.08 11.5962 14.08 15M11.4169 4.42391C11.4169 6.31489 9.88401 7.84783 7.99304 7.84783C6.10206 7.84783 4.56912 6.31489 4.56912 4.42391C4.56912 2.53294 6.10206 1 7.99304 1C9.88401 1 11.4169 2.53294 11.4169 4.42391Z",
                stroke: "#009877"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/navigationBar/NavBarDropdown.tsx

function NavBarDropdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  \n"
    ]);
    NavBarDropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function NavBarDropdown_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  width: 40px;\n  border-radius: 100%;\n  border: 1px solid ",
        ";\n  transition: background-color .3s ease-out;\n\n  svg {\n    width: 16px;\n\n    path {\n      transition: stroke .3s ease-out;\n    }\n\n    rect {\n      transition: fill .3s ease-out;\n    }\n  }\n\n  button:hover & {\n    background: ",
        ";\n\n    svg {\n      path {\n        stroke: white;\n      }\n\n      rect {\n        fill: white;\n      }\n    }\n  }\n"
    ]);
    NavBarDropdown_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






function NavBarDropdown(param) {
    var label = param.label, icon = param.icon, dropdownList = param.dropdownList;
    var ref = (0,router.useRouter)(), locales = ref.locales, locale = ref.locale, pathname = ref.pathname, asPath = ref.asPath, query = ref.query, push = ref.push;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNavBarDropdown, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown, {
            toggler: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledToggle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toggle, {
                    label: label,
                    icon: icon
                })
            }),
            dropdownItems: dropdownList.map(function(item) {
                return dropdownItem({
                    item: item,
                    locales: locales,
                    locale: locale,
                    pathname: pathname,
                    asPath: asPath,
                    query: query,
                    push: push
                });
            })
        })
    });
}
function Toggle(param) {
    var icon = param.icon, label = param.label;
    if (icon === "user") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserNavIcon, {
            title: label
        });
    }
    if (icon === "hamburger") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_MenuIcon, {
            title: label
        });
    }
    return label;
}
function dropdownItem(param) {
    var item = param.item, locales = param.locales, locale = param.locale, pathname = param.pathname, asPath = param.asPath, query = param.query, push = param.push;
    var langSwitchPattern = new RegExp("/{lang:(?:\\s*)(".concat(locales.join("|"), ")}"));
    var langSwitchMatches = item.linkIt.url.match(langSwitchPattern);
    if (langSwitchMatches === null || langSwitchMatches === void 0 ? void 0 : langSwitchMatches.length) {
        var newLocale = langSwitchMatches[1];
        return {
            id: item.id,
            onClick: function() {
                if (newLocale !== locale) {
                    push({
                        pathname: pathname,
                        query: query
                    }, asPath, {
                        locale: newLocale
                    });
                }
            },
            withSeparator: item.withSeparator,
            children: item.linkIt.text
        };
    }
    return {
        id: item.id,
        href: item.linkIt.url,
        target: item.linkIt.target,
        withSeparator: item.withSeparator,
        children: item.linkIt.text
    };
}
var StyledNavBarDropdown = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13e93303-0"
})(NavBarDropdown_templateObject());
var StyledToggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-13e93303-1"
})(NavBarDropdown_templateObject1(), function(p) {
    return p.theme.colors.green400;
}, function(p) {
    return p.theme.colors.green400;
});

// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(5741);
;// CONCATENATED MODULE: ./components/navigationBar/NavBarTextLink.tsx


function NavBarTextLink(param) {
    var url = param.url, text = param.text, target = param.target;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
        href: url,
        target: target,
        children: text
    });
}

;// CONCATENATED MODULE: ./components/navigationBar/NavigationBar.tsx

function NavigationBar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n  font-size: ",
        ";\n\n  > a {\n    color: inherit;\n    text-decoration: none;\n  }\n\n  @media ( max-width: 650px ) {\n    > *:not( ",
        " ) {\n      display: none;\n    }\n  }\n"
    ]);
    NavigationBar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





function NavigationBar(param) {
    var navigationBar = param.navigationBar;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledNavigationBar, {
        children: navigationBar.map(function(navBarItem) {
            if (navBarItem.typeHandle === "button") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBarButton, {
                    url: navBarItem.linkIt.url,
                    text: navBarItem.linkIt.text,
                    target: navBarItem.linkIt.target,
                    buttonStyle: navBarItem.buttonStyle,
                    color: navBarItem.buttonColor
                }, navBarItem.id);
            }
            if (navBarItem.typeHandle === "textLink") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBarTextLink, {
                    url: navBarItem.linkIt.url,
                    text: navBarItem.linkIt.text,
                    target: navBarItem.linkIt.target
                }, navBarItem.id);
            }
            if (navBarItem.typeHandle === "dropdown") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBarDropdown, {
                    label: navBarItem.label,
                    icon: navBarItem.icon,
                    dropdownList: navBarItem.dropdownList
                }, navBarItem.id);
            }
            return null;
        })
    });
}
var StyledNavigationBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba2aca3e-0"
})(NavigationBar_templateObject(), function(p) {
    return p.theme.typo.sizes.small;
}, StyledNavBarDropdown);


/***/ }),

/***/ 3974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useModalTraits; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
;// CONCATENATED MODULE: ./hooks/useKeyDown.tsx


var useKeyDown = function(keys, listener) {
    var deps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], skip = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var internalListener = (0,react.useCallback)(function(keyDownEvent) {
        if (skip) {
            return;
        }
        var key = keyDownEvent.key;
        var listenForKeys = Array.isArray(keys) ? keys : [
            keys
        ];
        if (listenForKeys.includes(key)) {
            listener(keyDownEvent);
        }
    }, [
        keys,
        skip
    ]);
    (0,react.useEffect)(function() {
        if (true) {
            window.addEventListener("keydown", internalListener, true);
            return function() {
                window.removeEventListener("keydown", internalListener, true);
            };
        }
    }, [
        internalListener
    ].concat((0,_to_consumable_array/* default */.Z)(deps)));
};
/* harmony default export */ var hooks_useKeyDown = (useKeyDown);

;// CONCATENATED MODULE: ./hooks/useOnClickOutside.tsx

function useOnClickOutside(ref, handler) {
    var skip = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    (0,react.useEffect)(function() {
        if (!skip) {
            var listener = function(event) {
                // Do nothing if clicking ref's element or descendent elements
                if (!ref.current || ref.current.contains(event.target)) {
                    return;
                }
                handler(event);
            };
            document.addEventListener("mousedown", listener, {
                passive: false
            });
            document.addEventListener("touchstart", listener, {
                passive: false
            });
            return function() {
                document.removeEventListener("mousedown", listener);
                document.removeEventListener("touchstart", listener);
            };
        }
    }, // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [
        ref,
        handler,
        skip
    ]);
}

;// CONCATENATED MODULE: ./hooks/useFocusTrap.tsx


var defaultElementsSelector = [
    'a[href]:not([tabindex="-1"])',
    'area[href]:not([tabindex="-1"])',
    'input:not([disabled]):not([tabindex="-1"])',
    'select:not([disabled]):not([tabindex="-1"])',
    'textarea:not([disabled]):not([tabindex="-1"])',
    'button:not([disabled]):not([tabindex="-1"])',
    'iframe:not([tabindex="-1"])',
    '[tabindex]:not([tabindex="-1"])',
    '[contentEditable=true]:not([tabindex="-1"])', 
].join(", ");
var useFocusTrap = function(elementRef) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _elementsSelector = ref.elementsSelector, elementsSelector = _elementsSelector === void 0 ? defaultElementsSelector : _elementsSelector, _additionalElements = ref.additionalElements, additionalElements = _additionalElements === void 0 ? [] : _additionalElements, _isTrapped = ref.isTrapped, isTrapped = _isTrapped === void 0 ? true : _isTrapped;
    hooks_useKeyDown("Tab", function(e) {
        var ref;
        var focusableElements = (0,_to_consumable_array/* default */.Z)(((ref = elementRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll(elementsSelector)) || []).concat((0,_to_consumable_array/* default */.Z)(additionalElements.map(function(el) {
            return el.current;
        }).filter(function(el) {
            return !!el;
        })));
        var activeElement = document.activeElement;
        var activeElementIndex = focusableElements.indexOf(activeElement);
        var first = focusableElements[0];
        var last = focusableElements[focusableElements.length - 1];
        var focusNext = function() {
            if (activeElement === last) {
                first.focus();
            } else {
                focusableElements[activeElementIndex + 1].focus();
            }
        };
        var focusPrevious = function() {
            if (activeElement === first) {
                last.focus();
            } else {
                focusableElements[activeElementIndex - 1].focus();
            }
        };
        e.preventDefault();
        if (e.shiftKey) {
            focusPrevious();
            return;
        }
        focusNext();
    }, [
        elementsSelector
    ], !isTrapped);
};
/* harmony default export */ var hooks_useFocusTrap = (useFocusTrap);

// EXTERNAL MODULE: ./hooks/usePreventBodyScroll.tsx
var usePreventBodyScroll = __webpack_require__(7325);
;// CONCATENATED MODULE: ./hooks/useModalTraits.tsx





var useModalTraits = function(param) {
    var isOpen = param.isOpen, close = param.close, containerRef = param.containerRef, _focusableElementsSelector = param.focusableElementsSelector, focusableElementsSelector = _focusableElementsSelector === void 0 ? undefined : _focusableElementsSelector, _includeInFocusTrap = param.includeInFocusTrap, includeInFocusTrap = _includeInFocusTrap === void 0 ? [] : _includeInFocusTrap, _focusOnOpen = param.focusOnOpen, focusOnOpen = _focusOnOpen === void 0 ? null : _focusOnOpen, _preventBodyScroll = param.preventBodyScroll, preventBodyScroll = _preventBodyScroll === void 0 ? true : _preventBodyScroll;
    var lastFocusBeforeOpen = (0,react.useRef)(null);
    // Close on Escape key
    hooks_useKeyDown("Escape", function() {
        close();
    }, [], !isOpen);
    // Close on click outside
    useOnClickOutside(containerRef, function(e) {
        e.preventDefault();
        close();
    }, !isOpen);
    // Trap focus
    hooks_useFocusTrap(containerRef, {
        isTrapped: isOpen,
        elementsSelector: focusableElementsSelector,
        additionalElements: includeInFocusTrap
    });
    // Prevent body scroll when open
    (0,usePreventBodyScroll/* default */.Z)(preventBodyScroll && isOpen, containerRef.current);
    (0,react.useEffect)(function() {
        if (isOpen) {
            lastFocusBeforeOpen.current = document.activeElement;
            if (focusOnOpen) {
                var ref, ref1;
                var el = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll(focusOnOpen)[0];
                el === null || el === void 0 ? void 0 : (ref1 = el.focus) === null || ref1 === void 0 ? void 0 : ref1.call(el);
            }
        } else {
            var ref2;
            (ref2 = lastFocusBeforeOpen.current) === null || ref2 === void 0 ? void 0 : ref2.focus();
        }
        return function() {
            var ref;
            (ref = lastFocusBeforeOpen.current) === null || ref === void 0 ? void 0 : ref.focus();
        };
    }, [
        isOpen,
        focusOnOpen,
        containerRef
    ]);
};
/* harmony default export */ var hooks_useModalTraits = (useModalTraits);


/***/ })

}]);